module.exports = __webpack_public_path__ + "static/img/23_shidu.3639d130.png";